query getCompanyDashboard($companyId: ID!) {
  url: getCompanyDashboard(companyId: $companyId)
}
